/**
 * Section heading for a grouped single-select list (see `groupKey` on
 * `SingleSelectOption` / `renderGroupHeading` on `SingleSelectProps`).
 * Renders the label centered with a divider line on each side, crossing
 * through the row to visually separate this section from the one above it.
 */
export const renderSectionDividerHeading = (label: string) => (
  <div className="flex items-center gap-2">
    <div className="h-px flex-1 bg-border" />
    <span className="shrink-0">{label}</span>
    <div className="h-px flex-1 bg-border" />
  </div>
);
